import {
  deleteRequest,
  getRequest,
  postRequest,
  uploadRequest,
} from "./api";

const advancedPath = "admin/push-notifications";

const withQuery = (path, values = {}) => {
  const params = new URLSearchParams();

  Object.entries(values).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      params.set(key, value);
    }
  });

  const query = params.toString();
  return query ? `${path}?${query}` : path;
};

export const getPushCapabilities = ({ signal } = {}) =>
  getRequest(`${advancedPath}/capabilities`, true, false, { signal });

export const sendLegacyPushNotification = ({
  platform = "all",
  request,
}) =>
  postRequest(
    withQuery("admin/push-notification", { platform }),
    request,
    true
  );

export const previewPushAudience = ({ request, signal } = {}) =>
  postRequest(`${advancedPath}/audience-preview`, request, true, { signal });

export const createPushNotification = ({ request, idempotencyKey }) =>
  postRequest(advancedPath, request, true, {
    headers: { "Idempotency-Key": idempotencyKey },
  });

export const listPushNotifications = ({ filters = {}, signal } = {}) =>
  getRequest(withQuery(advancedPath, filters), true, false, { signal });

export const getPushNotification = ({ jobId, signal } = {}) =>
  getRequest(`${advancedPath}/${jobId}`, true, false, { signal });

export const cancelPushNotification = ({ jobId }) =>
  postRequest(`${advancedPath}/${jobId}/cancel`, {}, true);

const replayPushNotification = ({ action, jobId, request, idempotencyKey }) =>
  postRequest(`${advancedPath}/${jobId}/${action}`, request ?? {}, true, {
    headers: { "Idempotency-Key": idempotencyKey },
  });

export const retryPushNotification = (params) =>
  replayPushNotification({ ...params, action: "retry" });

export const resendPushNotification = (params) =>
  replayPushNotification({ ...params, action: "resend" });

export const uploadPushImage = ({ file }) => {
  const data = new FormData();
  data.append("image", file);
  return uploadRequest(`${advancedPath}/images`, data);
};

export const listPushImages = ({ page = 0, pageSize = 20, signal } = {}) =>
  getRequest(
    withQuery(`${advancedPath}/images`, { page, pageSize }),
    true,
    false,
    { signal }
  );

export const deletePushImage = ({ assetId }) =>
  deleteRequest(`${advancedPath}/images`, assetId);

export const cleanupPushImages = ({ olderThanDays = 30 }) =>
  postRequest(
    withQuery(`${advancedPath}/images/cleanup`, { olderThanDays }),
    {},
    true
  );

export const listPushInstallations = ({ filters = {}, signal } = {}) =>
  getRequest(
    withQuery(`${advancedPath}/installations`, filters),
    true,
    false,
    { signal }
  );
